export const TIMEOUT_AXIOS_REQUEST: number = 100200;
export const DEBOUNCE_TWO_SECONDS: number = 2000;
export const DEBOUNCE_ONE_SECOND: number = 1000;
export const PAGE_INITIAL_VALUE: number = 0;
export const LIMIT_INITIAL_VALUE: number = 10;
export const CURRENCY_FORMATTER = 100;
export const PERCENTAGE_FORMATTER = 100;
export const ADMIN_PROFILE = 'admin';
export const CONTRACTING_EXPIRATION_TIME_IN_DAYS = 7;
export const ROWS_PER_PAGE_OPTION = [5, 20, 50, 100, 500, 700];
export const PRODUCT_ROWS_PER_PAGE_OPTION = [10, 20, 30, 50];
export const PRODUCT_INVALID_VALUE = 0;
export const ONE_HUNDRED_PERCENT_NUMERIC_FORMAT = 1;
export const PIX_KEY_MAX_LENGTH = 320;
export const EMAIL_MAX_LENGTH = 320;
export const PIX_KEY_MIN_LENGTH = 10;
export const CNPJ_LENGTH = 14;
export const CPF_LENGTH = 11;
export const MAX_NAME_CHARACTERS = 40;
export const BACKOFFICE_PROD_URL = 'https://motostore-backoffice.contadigitalmotorola.com.br/';
export const INVOICED_STATUS = 'invoiced';
export const INVOICING_RECEIVED_SSE_URL = 'voucher/subscribe/';
export const PAYMENT_RECEIVED_SSE_URL = 'billing-payment/subscribe/';
